/**
 * IS THE CAMERA BEING DRAGGED? The right or the middle button held, or shift and the left - the camera's own
 * gestures (hooks/useBattlefieldCamera `dragMode`). While it is, the ground and the figures slide under a pointer
 * that is not exploring the map, so nothing that follows the pointer (the hover readout, the cover cue's tooltip,
 * the hovered figure) should chase them: each change re-rendered far more than the map, mid-orbit (the stutter at
 * the table, 2026-10-29).
 */
export const draggingCamera = (e: { buttons?: number; shiftKey?: boolean }): boolean => {
  const buttons = e.buttons ?? 0;
  return (buttons & 6) !== 0 || (!!e.shiftKey && (buttons & 1) !== 0);
};
